import React from 'react'
import Header from '../../Layout/Header'
import Footer from '../../Layout/Footer'
import FAQ from './FAQ'
import SeoTagsFooter from './SeoTagsFooter'
import EsignWorkflowDiagram from './EsignWorkflowDiagram'

function AboutUs() {
  return (
    <div class="page_wrapper">
    <Header/>
     <main class="page_content">
     <section class="page_header text-center bg-dark section_decoration overflow-hidden" style={{backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')"}}>
  <div class="container">
    <h1 class="page_title text-white">About Us</h1>
    <ul class="breadcrumb_nav unordered_list justify-content-center">
      <li><a href="/">Home</a></li>
      <li class="active"><a href="#!"> About Us</a></li>
    </ul>
  </div>
  <div class="decoration_item shape_nate">
    <img src="assets/images/shapes/shape_nate.svg" alt="Shape Nate"/>
  </div>
  <div class="decoration_item shape_dollar_1 wow fadeInUp" data-wow-delay=".2s">
    <img src="assets/images/shapes/shape_dollar_1.webp"  data-parallax='{"y" : 100, "smoothness": 10}' alt="Shape Dollar"/>
  </div>
  <div class="decoration_item shape_dollar_2 wow fadeInUp" data-wow-delay=".2s">
    <img src="assets/images/shapes/shape_dollar_2.webp" data-parallax='{"y" : 100, "smoothness": 10}' alt="Shape Dollar"/>
  </div>
  <div class="decoration_item shape_dollar_3 wow fadeInUp" data-wow-delay=".3s">
    <img src="assets/images/shapes/shape_dollar_3.webp" data-parallax='{"y" : -100, "smoothness": 10}' alt="Shape Dollar"/>
  </div>
  <div class="decoration_item shape_dollar_4 wow fadeInUp" data-wow-delay=".3s">
    <img src="assets/images/shapes/shape_dollar_4.webp" data-parallax='{"y" : -100, "smoothness": 10}' alt="Shape Dollar"/>
  </div>
  <div class="decoration_item shape_pattern_1">
    <img src="assets/images/shapes/breadcrumb_shape_pattern_1.svg" alt="Shape Pattern"/>
  </div>
  <div class="decoration_item shape_pattern_2">
    <img src="assets/images/shapes/breadcrumb_shape_pattern_2.svg" alt="Shape Pattern"/>
  </div>
</section>
<section className="about_section section_decoration overflow-hidden">
      <div className="container">
        <div className="section_space">
          

          </div>

        <div className="row align-items-center justify-content-lg-between">
          <div className="col-lg-5">
            <div className="heading_block">
              <h3 className="heading_text">
              Smart Financial Solutions for Everyone
              </h3>
              <p className="heading_description mb-0">
              At Mokshiq, a product of Rakle Service Private Limited, we bring together AEPS, DMT, mATM, Utility Bill Payments, Recharges, and Instant Verification APIs into one seamless platform. Our focus is on secure, fast, and user-friendly services that make managing money simpler, smarter, and more accessible.
              </p>
            </div>
            <div className="row">
              <div className="col-lg-5 col-md-4 col-sm-5 col-6">
                <div className="funfact_block">
                  <div className="funfact_value">
                    <span className="odometer" data-count="200">50</span>
                    <span>+</span>
                  </div>
                  <h4 className="funfact_title mb-0">Services</h4>
                </div>
              </div>
              <div className="col-lg-5 col-md-4 col-sm-5 col-6">
                <div className="funfact_block">
                  <div className="funfact_value">
                    <span className="odometer" data-count="5">7</span>
                    <span>+</span>
                  </div>
                  <h4 className="funfact_title mb-0">Years Experience</h4>
                </div>
              </div>
            </div>
            <div className="btns_group pb-0 justify-content-start">
              <a className="btn btn-main bg-primary text-dark" href="#!">
                <span className="btn_label">About Us</span>
                <span className="btn_icon"><svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289L13.3431 0.928932C12.9526 0.538408 12.3195 0.538408 11.9289 0.928932C11.5384 1.31946 11.5384 1.95262 11.9289 2.34315L17.5858 8L11.9289 13.6569C11.5384 14.0474 11.5384 14.6805 11.9289 15.0711C12.3195 15.4616 12.9526 15.4616 13.3431 15.0711L19.7071 8.70711ZM0 9H19V7H0V9Z" fill="#012A2B"></path>
                </svg></span>
              </a>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="about_image">
              <div className="mac_image">
                <img src="assets/images/about/mac_image_1.webp" alt="MacBook Pro Image"/>
              </div>
              <div className="chart_image" data-parallax='{"y" : -70, "smoothness": 10}'>
                <img src="assets/images/about/chart_image_1.webp" alt="Chart Image"/>
              </div>
              <div className="mac_bottom_image">
                <img src="assets/images/shapes/shape_circle_1.webp" alt="Circle Shape"/>
              </div>
              <div className="decoration_item shape_dollar_1" data-parallax='{"y" : 50, "smoothness": 10}'>
                <img src="assets/images/shapes/shape_dollar_3.webp" alt="Circle Shape"/>
              </div>
            </div>
          </div>
        </div>

        {/* 3 Clean Dark Emerald Feature Cards with 3D Generated Icons & Interactive Hover */}
        <div className="mt-5 pt-3">
          <div className="row g-4">
            
            {/* Card 1: Our Mission */}
            <div className="col-lg-4">
              <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="feature_img_box flex-shrink-0">
                      <img src="/assets/images/about/mission_3d_target.png" alt="Our Mission 3D" width="42" height="42" className="object-fit-contain" />
                    </div>
                    <h3 className="card_title_text h4 font-weight-bold mb-0">Our Mission</h3>
                  </div>
                  <p className="text-white-50 small mb-0" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                    Making financial and digital services accessible to everyone with secure, reliable, and fast solutions.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2: What We Offer */}
            <div className="col-lg-4">
              <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="feature_img_box flex-shrink-0">
                      <img src="/assets/images/about/offer_3d_services.png" alt="What We Offer 3D" width="42" height="42" className="object-fit-contain" />
                    </div>
                    <h3 className="card_title_text h4 font-weight-bold mb-0">What We Offer</h3>
                  </div>
                  <p className="text-white-50 small mb-0" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                    AEPS, DMT, mATM, Utility Bill Payments, and Recharges in one place for hassle-free operations.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3: Why Choose Us */}
            <div className="col-lg-4">
              <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="feature_img_box flex-shrink-0">
                      <img src="/assets/images/about/choose_3d_growth.png" alt="Why Choose Us 3D" width="42" height="42" className="object-fit-contain" />
                    </div>
                    <h3 className="card_title_text h4 font-weight-bold mb-0">Why Choose Us</h3>
                  </div>
                  <p className="text-white-50 small mb-0" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                    Data-driven approach, 99.9% uptime SLA, transparent margins, and dedicated 24x7 customer support.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="decoration_item shape_lines_flow_1">
        <img src="assets/images/shapes/shape_nate_8.svg" alt="Shape Line Flow"/>
      </div>
      <div className="decoration_item shape_lines_flow_2">
        <img src="assets/images/shapes/shape_nate_9.svg" alt="Shape Line Flow"/>
      </div>
      <div className="decoration_item shape_dollar_1" data-parallax='{"y" : 100, "smoothness": 10}'>
        <img src="assets/images/shapes/shape_dollar_1.webp" alt="Shape dollar"/>
      </div>
      <div className="decoration_item shape_dollar_2" data-parallax='{"y" : -150, "smoothness": 10}'>
        <img src="assets/images/shapes/shape_dollar_3.webp" alt="Shape dollar"/>
      </div>
    </section>
    {/* Security Architecture & Safety First Diagram */}
    <section className="py-5 position-relative overflow-hidden" style={{ backgroundColor: '#001a14', borderTop: '1px solid rgba(204, 255, 0, 0.1)', borderBottom: '1px solid rgba(204, 255, 0, 0.1)' }}>
      <div className="container">
        <EsignWorkflowDiagram title="Safety First: Enterprise Security & Authentication" />
      </div>
    </section>
    <section className="team_section py-5" style={{ backgroundColor: '#012b2a' }}>
      <div className="container py-3">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-7 text-center">
            <span className="badge-lime mb-2 text-uppercase font-weight-bold" style={{ letterSpacing: '1px' }}>
              EXECUTIVE LEADERSHIP
            </span>
            <h2 className="heading_text text-white display-6 font-weight-bold">
              Meet Our Leadership Team
            </h2>
            <p className="heading_description mb-0 text-white-50">
              Meet our leadership team at Mokshiq. With expertise in finance, technology, and strategy, they drive our success forward.
            </p>
          </div>
        </div>

        <div className="row justify-content-center g-4">
          {/* Rohit Kushwaha */}
          <div className="col-lg-4 col-md-6">
            <div className="executive_team_card text-center h-100 shadow">
              <div className="member_photo_frame">
                <img src="assets/images/avatar/rohit_kushwaha.jpeg" alt="Rohit Kushwaha" />
              </div>
              <div>
                <h3 className="member_name">Rohit Kushwaha</h3>
                <span className="member_role">Co-Founder</span>
                <div className="d-flex justify-content-center gap-3 mt-2">
                  <a aria-label="Calling" href="tel:+916394856756" className="social_btn" title="Call Rohit">
                    <i className="fa-solid fa-phone"></i>
                  </a>
                  <a aria-label="Linkedin" href="https://www.linkedin.com/in/rohitkushwaha-rs/" target="_blank" rel="noreferrer" className="social_btn" title="LinkedIn Profile">
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                  <a aria-label="Instagram" href="https://www.instagram.com/yes_rohit/" target="_blank" rel="noreferrer" className="social_btn" title="Instagram Profile">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Sitaram Gauda */}
          <div className="col-lg-4 col-md-6">
            <div className="executive_team_card text-center h-100 shadow">
              <div className="member_photo_frame">
                <img src="assets/images/team/team_member_image_2.webp" alt="Sitaram Gauda" />
              </div>
              <div>
                <h3 className="member_name">Sitaram Gauda</h3>
                <span className="member_role">Co-Founder</span>
                <div className="d-flex justify-content-center gap-3 mt-2">
                  <a aria-label="Calling" href="tel:+917311104571" className="social_btn" title="Call Sitaram">
                    <i className="fa-solid fa-phone"></i>
                  </a>
                  <a aria-label="Linkedin" href="#!" className="social_btn" title="LinkedIn Profile">
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                  <a aria-label="Instagram" href="#!" className="social_btn" title="Instagram Profile">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <FAQ 
      title="About Mokshiq & Rakle Service Private Limited"
      subtitle="Learn more about our company mission, services, and security standards."
    />
  </main>
  <Footer/>
  <SeoTagsFooter/>
</div>
  )
}

export default AboutUs